import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { mapList } from '../common/rest.operators';

import {
    DEFAULT_LANGUAGE,
    Language,
    LanguageModelSetTransformer,
} from './i18n.model';

@Injectable()
export class I18nService {
    private readonly _storageKeyPrefix: string; // TODO refactor. authService uses the same prefix
    languages: Language[];

    get locale(): string {
        return localStorage.getItem(`${this._storageKeyPrefix}_locale`);
    }

    set locale(value: string) {
        localStorage.setItem(`${this._storageKeyPrefix}_locale`, value);
    }

    get currentLocale(): string {
        const lang = this.languages?.find(
            (e) => e.id.toString() === this._translateService.currentLang,
        );
        return lang?.initial;
    }

    constructor(
        private readonly _http: HttpClient,
        private readonly _translateService: TranslateService,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {
        this._storageKeyPrefix = this._appConfig.OAUTH.AUTHORIZATION_ENDPOINT;
    }

    // TODO system config module?
    listLanguages(forceReload?: boolean): Observable<Language[]> {
        if (!forceReload && this.languages) {
            return of(this.languages);
        }

        return (
            this._http
                .get(
                    `${this._appConfig.API_ENDPOINTS.USER}/system-config/configured-languages`,
                )
                // TODO revise
                .pipe(
                    mapList(new LanguageModelSetTransformer()),
                    catchError(() => of([DEFAULT_LANGUAGE])),
                    tap((model: Language[]) => {
                        this.languages = model;
                    }),
                )
        );
    }
}
